import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';

import { JSONRpc } from './service-jsonrpc';
import { Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';

import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class CustomerService {
    constructor(
        private http: HttpClient
      ) {}

    GetStore(): Observable<any> {
      let rpcMethod = new JSONRpc({
        jsonrpc : "2.0",
        method:"webservice.customer:GetStore"
      });
      return this.http.post<JSONRpc>(environment.webservice, rpcMethod);
    }

    getPublicStore(): Observable<any> {
      let rpcMethod = new JSONRpc({
        jsonrpc : "2.0",
        method:"webservice.customer:getPublicStore"
      });
      return this.http.post<JSONRpc>(environment.webservice, rpcMethod);
    }

    // BuyItems(ids, quantity): Observable<any> {
    BuyItems(ids): Observable<any> {
      
      let rpcMethod = new JSONRpc({
        jsonrpc : "2.0",
        method:"webservice.customer:BuyItems",
        params: {
          idsItem : ids,
          // sumQuantity: quantity
        }
      });
      return this.http.post<JSONRpc>(environment.webservice, rpcMethod);
    }
    buyPredefinedItem(): Observable<any> {
      let rpcMethod = new JSONRpc({
        jsonrpc : "2.0",
        method:"webservice.customer:buyPredefinedItem",
        params: {
        }
      });
      return this.http.post<JSONRpc>(environment.webservice, rpcMethod);
    }

    ignorePayment(cart, refCart): Observable<any> {
      
      let rpcMethod = new JSONRpc({
        jsonrpc : "2.0",
        method:"webservice.customer:ignorePayment",
        params: {
          cart : cart,
          refCart : refCart,
        }
      });
      return this.http.post<JSONRpc>(environment.webservice, rpcMethod);
    }

    // consumeCredit(comment:string): Observable<any> {
    //   let rpcMethod = new JSONRpc({
    //     jsonrpc : "2.0",
    //     method:"webservice.customer:consumeCredit",
    //     params: {
    //       comment : comment
    //     }
    //   });
    //   return this.http.post<JSONRpc>(environment.webservice, rpcMethod);
    // }

    // getAddress(): Observable<any> {
    //   let rpcMethod = new JSONRpc({
    //     jsonrpc : "2.0",
    //     method:"webservice.customer:getAddress"
    //   });
    //   return this.http.post<JSONRpc>(environment.webservice, rpcMethod);
    // }

    // updateAddress(tokencsrf, data): Observable<any> {
    //   let rpcMethod = new JSONRpc({
    //     jsonrpc : "2.0",
    //     method:"webservice.connexion:updateAddress",
    //     params: {
    //       token : tokencsrf,
    //       data : data
    //     }
    //   });
    //   return this.http.post<JSONRpc>(environment.webservice, rpcMethod);
    // }

    deleteAccount(clientid: any): Observable<any>  {
        let rpcMethod = new JSONRpc({
            jsonrpc : "2.0",
            method:"webservice.customer:deleteAccount",
            params : {
                clientid : clientid,
            }
        });
        return this.http.post<JSONRpc>(environment.webservice, rpcMethod);
    }
    autoVille(value): Observable<any>{
      let rpcMethod = new JSONRpc({
        jsonrpc: "2.0",
        method: "webservice.customer:autoVille",
        params: {
          value:value,
        }
      });
      return this.http.post<JSONRpc>(environment.webservice, rpcMethod);
    }
    getUrlRendezVous(): Observable<any> {
      let rpcMethod = new JSONRpc({
        jsonrpc : "2.0",
        method:"webservice.customer:getUrlRendezVous",
        params: {}
      });
      return this.http.post<JSONRpc>(environment.webservice, rpcMethod);
    }

    getCouponsByExpediteur(idclient, filters): Observable<any> {
      let rpcMethod = new JSONRpc({
        jsonrpc : "2.0",
        method: "webservice.customer:getCouponsByExpediteur",
        params: {idclient:idclient,filters:filters}
      });
      return this.http.post<JSONRpc>(environment.webservice, rpcMethod);
    }
  
    deleteCoupon(id:any): Observable<any> {
      let rpcMethod = new JSONRpc({
        jsonrpc: "2.0",
        method: "webservice.customer:deleteCoupon",
        params: {
          idCoupon: id
        }
      });
      return this.http.post<JSONRpc>(environment.webservice, rpcMethod);
    }
  
    getDataCouponsByExpediteur(idclient): Observable<any> {
      let rpcMethod = new JSONRpc({
        jsonrpc : "2.0",
        method: "webservice.customer:getDataCouponsByExpediteur",
        params: {idclient:idclient}
      });
      return this.http.post<JSONRpc>(environment.webservice, rpcMethod);
    }
    generateCodeVoucher(): Observable<any> {
      let rpcMethod = new JSONRpc({
        jsonrpc : "2.0",
        method: "webservice.customer:generateCodeVoucher",
        params: {}
      });
      return this.http.post<JSONRpc>(environment.webservice, rpcMethod);
    }
    createCoupon(userId, is_abonnement, voucher,destinataire,commentaire, send): Observable<any> {
      let rpcMethod = new JSONRpc({
        jsonrpc : "2.0",
        method: "webservice.customer:createCoupon",
        params: {
          userId:userId,
          is_abonnement:is_abonnement,
          voucher:voucher,
          destinataire:destinataire,
          commentaire:commentaire,
          send:send
        }
      });
      return this.http.post<JSONRpc>(environment.webservice, rpcMethod);
    }
    checkCoupon(codeCoupon): Observable<any> {
      let rpcMethod = new JSONRpc({
        jsonrpc : "2.0",
        method: "webservice.customer:checkCoupon",
        params: {codeCoupon:codeCoupon}
      });
      return this.http.post<JSONRpc>(environment.webservice, rpcMethod);
    }
  
    getCredits(): Observable<any> {
      let rpcMethod = new JSONRpc({
        jsonrpc : "2.0",
        method: "webservice.customer:getCredits",
        params: {}
      });
      return this.http.post<JSONRpc>(environment.webservice, rpcMethod);
    }
    getHistory(/*id*/): Observable<any> {
      let rpcMethod = new JSONRpc({
        jsonrpc : "2.0",
        method:"webservice.customer:getHistory",
        params: {
          //id: id
        }
      });
      return this.http.post<JSONRpc>(environment.webservice, rpcMethod);
    }

    getDataFacturation(): Observable<any> {
      let rpcMethod = new JSONRpc({
        jsonrpc : "2.0",
        method:"webservice.customer:getDataFacturation",
        params: {
        }
      });
      return this.http.post<JSONRpc>(environment.webservice, rpcMethod);
    }

  uploadLogoClient(file: File, clientId: string): Observable<any> {
    let data:FormData = new FormData();
    data.append('file_upload', file, file.name);
    data.append('clientId', clientId);
    return this.http.post(environment.webservice+"uploadLogoClient", data);
  }
}